import { Box, Typography } from "@mui/material";
import {
  Close,
  Done,
  HelpOutline,
  InfoOutlined,
  Pending,
} from "@mui/icons-material";
import { _STATUS } from "../constants/statusMapping";
import { V2_COLORS } from "../v2/constants/colors";

type StatusMeta = {
  color: string;
  bgColor: string;
  borderColor?: string;
  IconComponent: React.ElementType;
};

const STATUS_META: Record<string, StatusMeta> = {
  [_STATUS.success]: {
    color: "#387E47",
    bgColor: "#EDF5EE",
    borderColor: "#DAECDE",
    IconComponent: Done,
  },
  [_STATUS.warn]: {
    color: "#FFFFFF",
    bgColor: V2_COLORS.warning,
    IconComponent: Pending,
  },
  [_STATUS.error]: {
    color: "#DB382A",
    bgColor: "#FBEBEA",
    borderColor: "#F8D7D4",
    IconComponent: Close,
  },
  [_STATUS.not_applicable]: {
    color: "#666",
    bgColor: "#F5F5F5",
    borderColor: "#E0E0E0",
    IconComponent: InfoOutlined,
  },
  [_STATUS.not_acknowledged]: {
    color: "#E65100",
    bgColor: "#FFF3E0",
    borderColor: "#FFE0B2",
    IconComponent: Pending,
  },
  [_STATUS.red_solid]: {
    color: "#FFF",
    bgColor: "#DB382A",
    IconComponent: Close,
  },
  [_STATUS.blue_solid]: {
    color: "#FFF",
    bgColor: "#4E58B4",
    IconComponent: InfoOutlined,
  },
  [_STATUS.green_solid]: {
    color: "#FFF",
    bgColor: "#469E59",
    IconComponent: Done,
  },
};

const FALLBACK: StatusMeta = {
  color: "#666",
  bgColor: "#F5F5F5",
  IconComponent: HelpOutline,
};

interface OrderStatusBadgeProps {
  type?: string;
  label?: string;
}

export default function OrderStatusBadge({ type, label }: OrderStatusBadgeProps) {
  const meta = STATUS_META[type ?? ""] ?? FALLBACK;
  const displayLabel = label || "N/A";

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        pl: "4px",
        pr: "8px",
        py: "4px",
        borderRadius: "4px",
        color: meta.color,
        backgroundColor: meta.bgColor,
        border: meta.borderColor ? `1px solid ${meta.borderColor}` : "none",
        whiteSpace: "nowrap",
      }}
    >
      <meta.IconComponent sx={{ fontSize: 12 }} />
      <Typography
        component="span"
        sx={{
          color: "inherit",
          fontSize: "10px",
          fontWeight: 500,
          lineHeight: "12px",
          textTransform: "uppercase",
        }}
      >
        {displayLabel}
      </Typography>
    </Box>
  );
}
